const DOCUMENT_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx'];

export function getAttachmentKind(file) {
  if (!file) return null;
  const mime = String(file.type || '').toLowerCase();
  const ext = String(file.name || '').split('.').pop()?.toLowerCase();

  if (mime.startsWith('image/')) return 'image';
  if (mime.startsWith('video/')) return 'video';
  if (mime.startsWith('audio/')) return 'audio';
  if (mime === 'application/pdf' || DOCUMENT_EXTENSIONS.includes(ext)) return 'document';

  return null;
}

export function formatAttachmentSize(bytes = 0) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) {
    const kb = bytes / 1024;
    return `${Number.isInteger(kb) ? kb : kb.toFixed(1)} KB`;
  }
  const mb = bytes / (1024 * 1024);
  return `${Number.isInteger(mb) ? mb : mb.toFixed(1)} MB`;
}

export function buildAttachmentPreview(file) {
  const kind = getAttachmentKind(file);
  if (!kind) return null;

  const ext = String(file.name || '').split('.').pop()?.toUpperCase();
  const labels = {
    image: 'Image',
    video: 'Video',
    audio: 'Audio',
    document: ext === 'PDF' ? 'PDF document' : `${ext || 'Document'} file`,
  };

  return {
    kind,
    name: file.name || 'Attachment',
    label: labels[kind],
    size: formatAttachmentSize(file.size || 0),
  };
}

export function getLeadTemperature(score = 0) {
  if (score >= 70) return { key: 'hot', label: 'Hot' };
  if (score >= 30) return { key: 'warm', label: 'Warm' };
  return { key: 'cold', label: 'Cold' };
}

export function summarizeLeadInbox(contacts = []) {
  return contacts.reduce((summary, contact) => {
    summary.total += 1;
    summary.unread += Number(contact.unreadCount || 0);

    if (contact.isLead) {
      summary.leads += 1;
      if (getLeadTemperature(contact.leadScore || 0).key === 'hot') summary.hot += 1;
      if (contact.stage) {
        summary.stages[contact.stage] = (summary.stages[contact.stage] || 0) + 1;
      }
    }

    return summary;
  }, { total: 0, leads: 0, unread: 0, hot: 0, stages: {} });
}
